import { NonNullableStringParameter, useQueryParameter } from '@pba/react-router';
import { useMemo } from 'react';
import { defaultToolbar } from '../constants';
import type { ToolbarOption } from '../types';

export const useToolbar = (): ToolbarOption[] => {
  const toolbar = useQueryParameter('toolbar', NonNullableStringParameter);

  return useMemo(() => {
    if (!toolbar) {
      return defaultToolbar;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- Toolbar items are provided by the native application
    return toolbar.split(',') as ToolbarOption[];
  }, [toolbar]);
};
